/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
};

export = styles;

loadStyles([{"rawString":".ms-BasicMessageBarsExample .ms-MessageBar{margin:10px 0}"}]);
/* tslint:enable */